import SignupForm from '../components/signup-form/signup-form.component';

const Signup = () => {
    return(
        <div>
            <SignupForm />
        </div>
    )
}

export default Signup